import React, { useState, useRef, useEffect } from 'react';
import './classes/Footer.css';
import ReCAPTCHA from "react-google-recaptcha";
import { configData } from "../config";
import { useLocation } from 'react-router-dom';

const Footer = () => {
const [showPopup, setShowPopup] = useState(false);
const location = useLocation();
const domainName = window.location.host.replace(/^https?:\/\//, '');
  const currentPath = location.pathname;


  const getCookie = (cname) => {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  };

  const handleAccept = () => {
    setCookie("_site", "betasmww.preferati.net", 365);
    setShowPopup(false);
  };

  useEffect(() => {
    const user = getCookie("_site");
   console.log(currentPath);
    
    if (!user) {
      if (!currentPath.includes('/smww/cart') && !currentPath.includes('/smww/checkout') && !currentPath.includes('/smww_pay') && !currentPath.includes('/application') && !currentPath.includes('/user')) {
       
        setShowPopup(true);
      } else {
        setShowPopup(false);
      }
    }
  }, [currentPath]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [statelist, setStateList] = useState({});
  const [countrieslist, setCountriesList] = useState({});
  const[error,setError] = useState({});
  const [formData, setFormData] = useState({
    email: '',
    firstName: '',
    lastName: '',
    country: 'United States',
    city: '',
    state: '',
    pageURL: window.location.href, 
    emailLists: [],
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const app_url = configData.APP_URL;
  useEffect(() => {
    
    retrieveCountriesList();
    retrieveStateList();
  },[]);

  async function retrieveStateList() {
    const statelistresponse = await fetch(app_url + 'smwwstates/getstatelist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const statelistdata = await statelistresponse.json();
    const statelist = {};
    Object.keys(statelistdata.data.result).forEach(function(key) {
      statelist[key] = statelistdata.data.result[key];
    });
    setStateList(statelist);
   
  }

  async function retrieveCountriesList() {
    const countrieslistresponse = await fetch(app_url + 'smwwcountries/getcountrieslist', {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const countrieslistdata = await countrieslistresponse.json();
    const countrieslist = {};
    Object.keys(countrieslistdata.data.result).forEach(function(key) {
      countrieslist[key] = countrieslistdata.data.result[key];
    });
    setCountriesList(countrieslist);
    
  }

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsFormSubmitted(false); 
  };

  const validateForm = (data) => {
    const errors = [];
    
    if (!formData.email.trim()) {
      alert("E-mail address field is required.")
      return false;
      //errors.push("E-mail address field is required.");
    }
   if (!formData.firstName?.trim()) {
    alert("Please enter your first name.");
    return false;
  }

  if (!formData.lastName?.trim()) {
    alert("Please enter your last name.");
    return false;
  }

  if (!formData.country?.trim()) {
    alert("Please select your country.");
    return false;
  }

  if (!formData.state?.trim()) {
    alert("Please select your state.");
    return false;
  }

  if (!formData.emailLists || formData.emailLists.length === 0) {
    alert("Please select at least one email list.");
    return false;
  }

   const recaptchaValue = recaptchaRef.current.getValue();
          if (!recaptchaValue) {
            alert("Please verify the reCAPTCHA!")
          return false;
            //errors.push("Please verify the reCAPTCHA!");
           
          }
    return true;
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData((prevData) => {
        if (checked) {
          return { ...prevData, emailLists: [...prevData.emailLists, value] };
        } else {
          return {
            ...prevData,
            emailLists: prevData.emailLists.filter((list) => list !== value),
          };
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleFormSubmit = async e => {
    e.preventDefault();
     if (!validateForm(formData)) {
    return;
  }
    //alert(Object.keys(newErrors).length);
    
   // setError(newErrors);
    
    //if (Object.keys(newErrors).length === 0) {
      const postData = formData; 
      setIsFormSubmitted(true);
      setFormData({
        email: '',
        firstName: '',
        lastName: '',
        country: 'United States',
        city: '',
        state: '',
        pageURL: window.location.href, 
        emailLists: [],
      });
      const response = await fetch(app_url+'newsletter/putuserdetails', {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.result === "user_created") {
        setFormData({
          email: '',
          firstName: '',
          lastName: '',
          country: 'United States',
          city: '',
          state: '',
          pageURL: window.location.href, 
          emailLists: [],
        });
        
        
      }
      
    //}
    
  };

  const recaptchaRef = useRef(null);
  const sitekey = configData.GOOGLE_RECAPTCHA_SITE_KEY;

  

  return (
    <>
    <div id="footer">
    {showPopup && (
      <div className="cookie-container">
       <div className="cookie-wrapper">
          <header>
          <h2 className="cookie-header">Cookies</h2>
          </header>

          <div className="cookie-data">
          <p>We use cookies to personalize your experience. By continuing to visit this website you agree to our use of cookies.&nbsp;
            <a href={configData.DRUPAL_DOMAIN_URL+"/privacy"}>Learn More</a></p>
          </div>

          <div className="cookie-buttons">
          <button className="btn" id="acceptBtn" onClick={handleAccept}>Got it!</button>
          
          </div>
			</div>
      </div>
    )}
        <div className="footer">
          <div className="float_left l">
            <a href={configData.DRUPAL_DOMAIN_URL+"/contact"}>Contact Us</a> | <a href={configData.DRUPAL_DOMAIN_URL+"/directors"}>Our Staff</a> |{" "}
            <a href={configData.DRUPAL_DOMAIN_URL+"/privacy"}>Privacy</a>
            <br />
            US & Canada toll free: <a href="tel:888-95-24368">888-95-AGENT</a>
            <br />
            {/* UK <a href="tel:+44 (0) 8712 884799">+44 (0)871 288 4799</a> | */}
            International: <a href="tel:011-503-445-7105">011-503-445-7105</a>
          </div>
          <div className="float_left m">
            <div align="center" className="newsletter_btn_wrapper">
              <a
                className="newsletter_btn"
                onClick={openModal}
              >
                JOIN OUR NEWSLETTER
              </a>
            </div>
          </div>
          {/* <div style={{ marginTop: "-23px" }} /> */}
          {domainName === configData.RSMWW_DOMAIN && 
            <div className='blogo'></div>
          }
          {domainName === configData.RSMWW_AGENCY_DOMAIN && 
            <div className='agency-blogo'></div>
          }
          {domainName === configData.RSMWW_SCOUT_DOMAIN && 
            <div class="scout-blogo"></div>
          }
          <div className="float_right r">
            <span>
            Sports Management Worldwide <br />
            500 Ala Moana Building 7, Suite 400<br />
            Honolulu, Hawaii 96813<br />
            Copyright © {new Date().getFullYear()} | All Rights Reserved.<br />
            </span>
            {domainName === configData.RSMWW_AGENCY_DOMAIN && 
              <span>
                <a href="https://www.instagram.com/smwwagency/">
                  <img src="/basic/web/images/agency_footer_instagram_logo.png" style={{width: "30px", margin: "5px 0"}} />
                </a>
                <a href="https://twitter.com/SMWWagency">
                  <img src="/basic/web/images/agency_footer_twitter_logo.png" style={{width: "30px", margin: "5px 0"}} />
                </a>
              </span>
            } 
          </div>
          <div style={{ clear: "both" }}>&nbsp;</div>
          <div>&nbsp;</div>
        </div>
      </div>
      {domainName === configData.RSMWW_DOMAIN && 
      <footer id="sticky">
        <div className='sticky-apply-now-button'>
          <a href="/application">
            Apply Now
          </a>
        </div>
      </footer>
}

      {isModalOpen && (
        <div className="footer-newsletter-modal-overlay">
          <div className="footer-newsletter-modal-content">
            <span className="footer-newsletter-close" onClick={closeModal}>
              &times;
            </span>
            <h2>SMWW Newsletter</h2>
            <p>Thank you for joining the Sports Management Worldwide newsletter! You're joining the thousands of sports industry enthusiasts looking to gain or further their sports knowledge.</p>
            <p>In order for us to better understand our audience so we can craft the best experience possible, please take a minute to tell us a little bit more about yourself.</p>
            <p>Please feel free to contact us should you have any questions or ideas.</p>
            <p>Thank you,<br />
            Sports Management Worldwide<br />
            503-445-7105<br />
            info@SMWW.com</p>

            {!isFormSubmitted ? (
              <form onSubmit={handleFormSubmit} className='footer-newsletter-form' noValidate>
                <label>Email<span style={{color: "red"}}>&nbsp;*</span></label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <label>First Name<span style={{color: "red"}}>&nbsp;*</span></label>
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
                <label>Last Name<span style={{color: "red"}}>&nbsp;*</span></label>
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
                <label>Country<span style={{color: "red"}}>&nbsp;*</span></label>
                <select name="country" value={formData.country} onChange={handleInputChange}>
                <option value="">Select Country</option>
                {Object.keys(countrieslist).map(item => {
                  return <option key={countrieslist[item].label} value={countrieslist[item].label}>{countrieslist[item].label}</option>
                })}
                </select>
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
                <label>State/Province<span style={{color: "red"}}>&nbsp;*</span></label>
                  <select name="state" value={formData.state} onChange={handleInputChange}>
                    <option value=" ">Select a State or Province</option>
                    <option value="Outside the US or Canada">Outside the US or Canada</option>
                    {Object.keys(statelist).map(state => {
                      return <option key={statelist[state].name} value={statelist[state].name}>{statelist[state].name}</option>;
                    })}
           
                  </select>
                <label>Email Lists<span style={{color: "red"}}>&nbsp;*</span></label>

        <div className="footer-newsletter-checkbox-group">
        <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Athlete-Management"
              name="emailLists"
              value="Athlete Management"
              checked={formData.emailLists.includes('Athlete Management')}
              onChange={handleInputChange}
            />
            <label htmlFor="Athlete-Management">Athlete Management</label>
          </div>
          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Baseball"
              name="emailLists"
              value="Baseball"
              checked={formData.emailLists.includes('Baseball')}
              onChange={handleInputChange}
            />
            <label htmlFor="Baseball">Baseball</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Basketball"
              name="emailLists"
              value="Basketball"
              checked={formData.emailLists.includes('Basketball')}
              onChange={handleInputChange}
            />
            <label htmlFor="Basketball">Basketball</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Conferences-and-Events"
              name="emailLists"
              value="Conferences and Events"
              checked={formData.emailLists.includes('Conferences and Events')}
              onChange={handleInputChange}
            />
            <label htmlFor="Conferences-and-Events">Conferences and Events</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Cricket"
              name="emailLists"
              value="Cricket"
              checked={formData.emailLists.includes('Cricket')}
              onChange={handleInputChange}
            />
            <label htmlFor="Cricket">Cricket</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="eSports"
              name="emailLists"
              value="eSports"
              checked={formData.emailLists.includes('eSports')}
              onChange={handleInputChange}
            />
            <label htmlFor="eSports">eSports</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Football"
              name="emailLists"
              value="Football"
              checked={formData.emailLists.includes('Football')}
              onChange={handleInputChange}
            />
            <label htmlFor="Football">Football</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Hockey"
              name="emailLists"
              value="Hockey"
              checked={formData.emailLists.includes('Hockey')}
              onChange={handleInputChange}
            />
            <label htmlFor="Hockey">Hockey</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Motorsports"
              name="emailLists"
              value="Motorsports"
              checked={formData.emailLists.includes('Motorsports')}
              onChange={handleInputChange}
            />
            <label htmlFor="Motorsports">Motorsports</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Rugby"
              name="emailLists"
              value="Rugby"
              checked={formData.emailLists.includes('Rugby')}
              onChange={handleInputChange}
            />
            <label htmlFor="Rugby">Rugby</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Soccer"
              name="emailLists"
              value="Soccer"
              checked={formData.emailLists.includes('Soccer')}
              onChange={handleInputChange}
            />
            <label htmlFor="Soccer">Soccer</label>
          </div>

          <div className="footer-newsletter-checkbox-item">
            <input
              type="checkbox"
              id="Sports-Management-Graduate-Programs"
              name="emailLists"
              value="Sports Management Graduate Programs (MBA, Ph.D, Ed.D, MASL)"
              checked={formData.emailLists.includes('Sports Management Graduate Programs (MBA, Ph.D, Ed.D, MASL)')}
              onChange={handleInputChange}
            />
            <label htmlFor="Sports-Management-Graduate-Programs">Sports Management Graduate Programs (MBA, Ph.D, Ed.D, MASL)</label>
          </div>
        </div>

<span className='newsletter-footer-desc'>By submitting this form, you are consenting to receive marketing emails 
  from: Sports Management Worldwide, 1100 NW Glisan Suite 2B, www.smww.com, Portland OR, OR, 97209, US, http://www.sportsmanagementworldwide.com. You can revoke your consent to receive emails at any time by using 
  the SafeUnsubscribe® link, found at the bottom of every email. 
  <a>Emails are serviced by Constant Contact</a></span>
  <br />

  <div className="footer-recaptcha">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={sitekey}
              size="visible"
              required
            />
            </div>

        <button type="submit" className="footer-newsletter-submit">Sign Up</button>
              </form>
            ) : (
              <div className="footer-newsletter-thankyou">
                Thank you for your interest!<br />
                Someone from SMWW will be contacting you soon.
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Footer;
